<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/page1-bg.png">
    <img class="header-phone" src="@/assets/page1-bg-phone.png">
    <img class="logo" src="@/assets/logo.png" alt="logo">
    <!-- <div class="title-bg"></div> -->
    <div class="title-text">Ultimate Hero Class</div>
    <!-- <div class="title-text1">Beyond Power</div> -->
    <div class="content">
      <div class="content-wrapper">
        <p>When the world faces its greatest crisis, you must assemble the ultimate hero team to stop the villain onslaught.</p>
        <p>1.Ultimate Ability Awakening</p>
        <p>Unlock never-before-seen power evolutions</p>
        <p>2.Reach the Pinnacle of Glory</p>
        <p>Battle fierce rivals for championship supremacy</p>
        <p>3.Breathtaking Combat Skills</p>
        <p>Immerse yourself in epic, visually stunning ability effects</p>
        <p>4.Diverse & Thrilling Game Modes</p>
        <p>Experience endless fun with multiple unique playstyles</p>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .header-img{
    width: 100%;
    // height: 1080px;
  }
  .logo{
    position: absolute;
    top: 20px;
    left: 100px;
    width: 160px;
    height: 160px;
  }
  .header-phone{
    display: none;
  }
  .title-bg{
    position: absolute;
    top: 180px;
    left: calc(50% - 340px);
    width: 680px;
    height: 254px;
    background: url(../assets/title-bg.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    font-size: 120px;
    font-family: titleFont;
    padding-top: 20px;
    text-shadow: 4px 4px 8px rgba(255, 255, 255, 1);
  }
  .title-text{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 260px;
    left: calc(50% - 530px);
    color: #fff;
    text-shadow: 4px 4px 10px rgb(23, 123, 236);
  }
  .title-text1{
    font-size: 100px;
    font-family: titleFont;
    position: absolute;
    top: 360px;
    left: calc(50% - 380px);
    color: #fff;
    text-shadow: 4px 4px 10px rgb(23, 123, 236);
  }
  .content{
    position: absolute;
    padding: 36px;
    top: 560px;
    left: calc(50% - 600px);
    width: 1200px;
    height: 680px;
    background: url(../assets/content-bg.png);
    background-size: 100% 100%;
    font-size: 30px;
    .content-wrapper{
      max-height: 660px;
      overflow: auto;
      p{
        margin-bottom: 20px;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .header-content{
    .title-bg{
      top: 120px;
    }
    .content{
      top: 400px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 870px;
    }
    .logo{
      top: 20px;
      left: 20px;
      width: 120px;
      height: 120px;
    }
    .title-bg{
      top: 10px;
      left: calc(50% - 170px);
      width: 340px;
      height: 127px;
      font-size: 70px;
      padding-top: 0;
    }
    .title-text{
      font-size: 38px;
      font-family: titleFont;
      position: absolute;
      top: 140px;
      left: calc(50% - 180px);
    }
    .title-text1{
      font-size: 38px;
      font-family: titleFont;
      position: absolute;
      top: 180px;
      left: calc(50% - 120px);
    }
    .content{
      top: 320px;
      padding: 36px;
      left: calc(50% - 278px);
      width: 556px;
      height: 430px;
      max-height: 430px;
      overflow: auto;
      background: url(../assets/content-phone-bg.png);
      background-size: 100% 100%;
      .content-wrapper{
        max-height: 420px;
        overflow: auto;
      }
    }
  }
}
</style>